import React from "react";
import "./ChatMessage.css";

const ChatMessage = ({ message }) => {
  return (
    <div className={`chat-message ${message.type}`}>
      <div className="message-bubble">{message.text}</div>
    </div>
  );
};

export default ChatMessage;
